<ion-content>
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div
      class="constrained-content flex-space-between"
      style="align-items: center"
    >
      Upgrade to create service accounts for integrations like Zapier
      <ion-button
        fill="outline"
        color="light"
        class="btn-small"
        [routerLink]="'/upgrade'"
        [queryParams]="{ plan: 'startup' }"
      >
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <div class="constrained-content">
    <ion-grid class="grid-no-padding">
      <ion-row>
        <ion-col size="6" size-md="6">
          <ion-card class="outline-card report-card">
            <ion-list>
              <ion-item class="transparent-bg" button="false">
                <img
                  class="zapier-logo"
                  src="{{
                    environment.assetsBaseUrl + '/imgs/zapier-logo_black.svg'
                  }}"
                  slot="start"
                  style="
                    border-radius: 10px;
                    max-width: 100px;
                    background: white;
                    padding: 5px;
                  "
                />
                <ion-label text-wrap>
                  <h3>Integrate with Zapier</h3>
                  <p>
                    <a
                      href="https://zapier.com/developer/public-invite/170323/75d6d7c7fbea3e022e73625f25d964e6/"
                      target="_blank"
                      >Click here to get access to the beta</a
                    >. If you need help setting up your account, you can
                    <a
                      href="https://docs.unthread.io/integrations/connecting-zapier"
                      target="_blank"
                      >learn more on our helpdesk</a
                    >.
                  </p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-card>
        </ion-col>
        <ion-col size="6" size-md="6">
          <ion-card class="outline-card report-card">
            <ion-list>
              <ion-item class="transparent-bg" button="false">
                <ion-icon
                  name="code-slash-outline"
                  style="font-size: 2rem; margin-right: 20px"
                ></ion-icon>
                <ion-label text-wrap>
                  <h3>Use the Unthread API</h3>
                  <p>
                    The Unthread API allows you to access your account data on
                    your terms. To get started,
                    <a
                      href="https://docs.unthread.io/api-introduction/using-api"
                      target="_blank"
                      >read our documentation</a
                    >.
                  </p>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div class="flex-space-between" style="padding: 15px 5px 0 3px">
      <div class="button-container flexed-align-center">
        <ion-searchbar
          mode="ios"
          class="rounded-search-bar"
          placeholder="Search..."
          showCancelButton="never"
          [(ngModel)]="searchText"
        ></ion-searchbar>

        <ion-button
          color="dark"
          fill="clear"
          class="hidden-sm"
          (click)="showInactive = !showInactive; loadServiceAccounts()"
          [hidden]="isLoading"
        >
          <ion-icon
            [name]="showInactive ? 'checkmark-circle' : 'ellipse-outline'"
            class="padded-icon checkbox-icon"
          >
          </ion-icon>
          Show inactive
        </ion-button>
      </div>

      <div class="button-container flexed-align-center">
        <ion-button
          (click)="createServiceAccount()"
          [disabled]="!featureEnabled"
        >
          <span class="text-with-right-icon hidden-sm">
            Add service account
          </span>
          <ion-icon name="add-outline"></ion-icon>
        </ion-button>
      </div>
    </div>
    <ion-card class="outline-card" style="margin-top: 10px">
      <ngx-datatable
        [limit]="100"
        [loadingIndicator]="isLoading"
        class="material"
        [columnMode]="ColumnMode.force"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="50"
        [scrollbarH]="true"
        [rows]="serviceAccounts | filterCollection: searchText : ['name']"
        trackByProp="id"
      >
        <ngx-datatable-column name="Name" prop="name" [minWidth]="200">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            {{ value }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Projects" prop="projects" [minWidth]="200">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            {{ displayProjects(row) }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Role" [maxWidth]="150" [minWidth]="130">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            <div
              *ngIf="row.role === TENANT_USER_ROLES.OWNER"
              ngxTippy
              data-tippy-content="Can configure all aspects of the workspace and view all data in the workspace"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              <ion-icon name="shield-checkmark-outline"></ion-icon>
              Owner
              <a (click)="changeRole(row.id)" *ngIf="authService.isTenantOwner">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>

            <div
              *ngIf="row.role === TENANT_USER_ROLES.ADMIN"
              ngxTippy
              data-tippy-content="Can configure all aspects of the workspace"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              <ion-icon name="shield-outline"></ion-icon>
              Admin
              <a (click)="changeRole(row.id)" *ngIf="authService.isTenantAdmin">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>

            <div
              *ngIf="row.role === TENANT_USER_ROLES.STANDARD"
              ngxTippy
              data-tippy-content="Can access their own customers and conversations"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              Standard
              <a (click)="changeRole(row.id)" *ngIf="authService.isTenantAdmin">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Status" [maxWidth]="150" [minWidth]="130">
          <ng-template
            let-value="value"
            let-row="row"
            ngx-datatable-cell-template
          >
            <ion-badge color="danger" *ngIf="value === 'inactive'"
              >Inactive</ion-badge
            >
            <ion-badge color="success" *ngIf="value === 'active'"
              >Active</ion-badge
            >
          </ng-template>
        </ngx-datatable-column>
        <!-- <ngx-datatable-column name="Role" prop="role">
          <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div
              *ngIf="value === USER_ROLES.ADMIN"
              ngxTippy
              data-tippy-content="Can manage all settings and configurations"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              <ion-icon name="shield-half-outline"></ion-icon>
              Admin
              <a (click)="changeRole(row)">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>
            <div
              *ngIf="value === USER_ROLES.STANDARD"
              ngxTippy
              data-tippy-content="Can access the inbox"
              [tippyProps]="{
                placement: 'bottom'
              }"
            >
              Standard
              <a (click)="changeRole(row)">
                <ion-icon name="chevron-down-outline"></ion-icon>
              </a>
            </div>
          </ng-template>
        </ngx-datatable-column> -->
        <ngx-datatable-column
          name="Date"
          prop="createdAt"
          [minWidth]="170"
          [maxWidth]="170"
          [sortable]="false"
        >
          <ng-template
            let-value="value"
            let-row="row"
            ngx-datatable-cell-template
          >
            {{ value | date: "MMM d yyyy h:mm a" }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="" prop="id" [sortable]="false">
          <ng-template
            let-row="row"
            let-value="value"
            ngx-datatable-cell-template
          >
            <a
              (click)="disableServiceAccount(row)"
              title="Disable this service account"
              ><span>Disable</span></a
            >
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </ion-card>
  </div>
</ion-content>
